import React from 'react';
import styled from 'styled-components';

// NOTE: Placeholder (ericjim)
const PromoContainer = (props) => {
  return (
    <div>
    </div>
  );
};

export default PromoContainer;
